export const PACK_CLICK_SOURCE = 'loswp--tabs-hero-pack--hero';
export const PDF_CLICK_SOURCE = 'loswp--tabs-hero-pdf--hero';
export const IMPRESSION_SOURCE = 'loswp--tabs-hero--impression';
export const THUMBNAIL_CLICK_SOURCE = 'loswp--tabs-hero-pdf--thumbnail';
export const TAB_PACK_CLICK_SOURCE = 'loswp--tabs-hero-pack--tab';
export const TAB_PDF_CLICK_SOURCE = 'loswp--tabs-hero-pdf--tab';
